import { render, staticRenderFns } from "./TheAboutStep.vue?vue&type=template&id=d08450f4&scoped=true"
import script from "./TheAboutStep.vue?vue&type=script&lang=js"
export * from "./TheAboutStep.vue?vue&type=script&lang=js"
import style0 from "./TheAboutStep.vue?vue&type=style&index=0&id=d08450f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08450f4",
  null
  
)

export default component.exports